function parseJsonOrFallback(value, fallback) {
  if (typeof value !== 'string') return value ?? fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function parseJsonObject(value, fallback = {}) {
  const parsed = parseJsonOrFallback(value, fallback);
  return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : fallback;
}

export function parseJsonArray(value, fallback = []) {
  const parsed = parseJsonOrFallback(value, fallback);
  return Array.isArray(parsed) ? parsed : fallback;
}
